window.ItemsCategory = {
	
	manageLogo : function(categoryId){
		
		var title = Loc.g('Logo de la catégorie');
		
		MyWindow.load('itemscategories', 
			{
				action		: 'manageLogo',
				categoryId		: categoryId,
			},
			{
				title		: title,
				buttons		: [
					{
						text : Loc.g("Fermer"), click : function(){
							MyWindow.close();
						}
					}
				],
				close: function() {
					Utils.reload();
				},
				callback	: function(){}
			},
			
			'json'
		);
		
	},
	
	deleteLogo : function(categoryId){
		
		MyFacture.post('itemscategories',  {action : 'deleteLogo', categoryId: categoryId}, function(datajson){
			$('#itemsCategoryLogoManagement .itemsCateLogo').hide();
			$('#itemsCategoryLogoManagement .itemsCateNoLogo').show();
		}, 'json');
		
	},
			
	updateLogo: function(object){

		$('#itemsCategoryLogoManagement .itemsCateLogo').show();
		$('#itemsCategoryLogoManagement .itemsCateNoLogo').hide();

		var file = object.file;
		$('#itemsCategoryLogoManagement .itemsCateLogo img').attr('src',file);
		
	},
	
	editItemsCategory: function(rowSelection){
		
		var title = Loc.g('Modifier la catégorie des produits');
		var button	= Loc.g("Modifier la catégorie");
		
		
		MyWindow.load('itemscategories', 
			{
				action		: 'massToggleCategory',
				items		: rowSelection,
			},
			{
				title		: title,
				buttons		: [
					{
						text : Loc.g("Annuler"), click : function(){
							MyWindow.close();
						}
					},
					{
						text : button,
						'class' : 'btn btn-primary', 
						click : function(){
							$("#massToggleCategoryForm").submit();
						}
					}
				],
				callback	: function(){ItemsCategory.preparemassToggleCategory();}
			},
			
			'json'
		);
			
	},
	
	preparemassToggleCategory: function(){

		var formId = "massToggleCategoryForm";
		MyForm.prepare(formId, "itemscategories&action=recordmassToggleCategory", {
			success:function(data){
				MyWindow.close();
				if (data.status === "ok"){
					MyWindow.alert(Loc.g('Les modifications ont correctement été appliquées'), {type:'confirm'});
					Utils.reload();
				} else {
					MyWindow.alert(Loc.g('Une erreur est survenue'), {type:'error'});
				}
			}, 
			dataType: "json"
		}, true);
		
	},
	
	itemsCategoryForm: function(id){
	
		var title = id === undefined ? Loc.g('Nouvelle catégorie de produits') : Loc.g('Modifier la catégorie de produits');
	
		var options = {
			title	: title,
			width: 600,
			buttons	: [
				{
					text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}
				},
				{
					text : Loc.g("Enregistrer"), click : function(){
						$("#itemsCategoryForm").submit();
					}
				}
			],
			callback	: function(){ItemsCategory.prepareItemsCategoryForm();}
		};

		MyWindow.load("itemscategories", {action:"itemsCategoryForm", icid:id}, options);
	
	},
			
	prepareItemsCategoryForm: function(){
		
		var formId = "itemsCategoryForm";
		var options = {success:function(data){
			var formIsOk = MyForm.processJson(data, "itemsCategoryForm");
			if (formIsOk){
				MyWindow.close();
				Utils.reload();
			}
		}, dataType:"json"};
	
		var data = {action: 'recorditemsCategoryForm'};
		MyForm.prepare(formId, "itemscategories&"+$.param(data), options, true);
		MyFacture.initEvent();
		MyTabs.initHorizontal('itemsCategoryForm');
		
	},
			
	itemsCategoryDeleteForm: function(id){
		
		var options = {

				type	: 'warning',
				buttons : [
					{
						text : Loc.g("Annuler"), 
						click : function(){
							$(this).dialog("close");
						}
					},
					{
						text : Loc.g("Supprimer"), 
						click : function(){
							$(this).dialog("close");
							MyFacture.post("itemscategories", {action:"itemsCategoryDeleteForm", id:id}, function(data){
								Utils.reload();
							}, "json");
						}
					}
				]
			};
			
			MyWindow.alert(Loc.g('Supprimer la catégorie ? Les catégories enfants seront également supprimées et les produits contenus déliés.'), options);

	}
	
};

window.ItemsCategoryList = {
	
	initNestableList : function(){
		$('.dd').nestable({
			group: 1,
			maxDepth: 1000000000
		});
		
		$('.dd').on('change', function() {
			var orderedCategories = $('.dd').nestable('serialize');
			
			MyFacture.post("itemscategories", {action:"itemsCategoriesReorder", orderedCategories:orderedCategories}, function(data){
			}, "json");
			
		});
		
	}
	
};